export const ColorPalette = ({ isActive }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7077 10C17.7077 15.9245 11.3804 10.6649 9.99935 13.4314C9.14287 15.1471 12.4209 17.2917 9.99935 17.2917C5.74215 17.2917 2.29102 14.0271 2.29102 10C2.29102 5.97293 5.74215 2.70834 9.99935 2.70834C14.2565 2.70834 17.7077 5.97293 17.7077 10Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
    />
    <path
      d="M9.58268 6.45834C9.58268 7.03363 9.11631 7.5 8.54102 7.5C7.96572 7.5 7.49935 7.03363 7.49935 6.45834C7.49935 5.88304 7.96572 5.41667 8.54102 5.41667C9.11631 5.41667 9.58268 5.88304 9.58268 6.45834Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
    />
    <path
      d="M7.08268 10C7.08268 10.5753 6.61631 11.0417 6.04102 11.0417C5.46572 11.0417 4.99935 10.5753 4.99935 10C4.99935 9.42471 5.46572 8.95834 6.04102 8.95834C6.61631 8.95834 7.08268 9.42471 7.08268 10Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
    />
    <path
      d="M13.7493 7.70834C13.7493 8.28363 13.283 8.75 12.7077 8.75C12.1324 8.75 11.666 8.28363 11.666 7.70834C11.666 7.13304 12.1324 6.66667 12.7077 6.66667C13.283 6.66667 13.7493 7.13304 13.7493 7.70834Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
    />
  </svg>
)

export default ColorPalette
